module.exports = __webpack_public_path__ + "static/media/portrait.3a044ab9.jpg";